export const iconFontAwesomeMapsTaxi = (
	<i className="fa-solid fa-taxi"></i>
);
